export default theme => ({
  tableRow: {
    cursor: "pointer",
  },
  tableRow__disabled: {
    cursor: "initial",
    backgroundColor: theme.palette.secondary.light,
  },
});
